import React, {useState, useEffect, useContext} from 'react';
import {UserContext} from '@context/UserContext';
import {ContentContext} from "@context/ContentContext";
import {TemplateContext} from '@common/context/TemplateContext';
import TitleHeaderRight from "./TitleHeaderRight";
import {BrandContext} from "@context/BrandContext";
import TitleNavigationDevelopment from "./TitleNavigationDevelopment";

const DefaultTitle = props => {
    const {user, userLoading, setUser} = useContext(UserContext);
    const {content, contentLoading} = useContext(ContentContext);
    const {name, iconComponent, shortcut} = useContext(TemplateContext);
    const brandConfig = useContext(BrandContext);

    return (
        <div className={'js-header'}>
            <div className="ch-page-header" style={{backgroundImage: 'url(' + (content.backgroundImage ? content.backgroundImage : 'https://cdn.edjin.com/static/users/lesson/img/headImages/hotmaths.jpg') + ')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                <div>
                    <div className="ch-page-header-title" style={{display: 'flex',align_items: 'center',justify_content: 'center'}}>
                        {shortcut?.iconClass && (
                            <div className="cont-head-icon cont-head-blk" data-icon={shortcut.iconClass}>
                                <svg width="60px" height="60px" viewBox="0 0 128 128" aria-hidden={'true'}>
                                    <use href={'#' + shortcut.iconClass + (shortcut != undefined && shortcut.darkBGVersion ? '-onDark' : '')}/>
                                </svg>
                            </div>
                        )}
                        <h1 className="ch-page-header-title-main">{name}</h1>
                    </div>
                </div>
                {!user.publicSession && brandConfig.useDevelopmentNavigation ?
                    <TitleNavigationDevelopment /> :
                    <TitleHeaderRight />
                }
            </div>
        </div>
    )
}

export default DefaultTitle;